export const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 10000, min: 1580 },
    items: 5,
  },
  largeDesktop: {
    breakpoint: { max: 1580, min: 1250 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1250, min: 950 },
    items: 3,
  },
  small: {
    breakpoint: { max: 950, min: 650 },
    items: 2,
  },
  extrasmall: {
    breakpoint: { max: 650, min: 0 },
    items: 1,
  },
}
